import { StyleSheet } from '@react-pdf/renderer';

export const chartWidth = 190;
export const chartHeight = Math.floor(chartWidth / 1); // Divider = <ResponsiveContainer/> Ratio of ReCharts.

export const angleGuiWidth = 325;
export const angleGuiHeight = 325;

export const headerHeight = 75;
export const footerHeight = 40;

const pdfDocStyles = StyleSheet.create({
  page: {
    color: 'black',
    fontFamily: 'ProximaNova',
    paddingTop: headerHeight,
    paddingBottom: footerHeight,
  },
  grayDotLabel: {
    fontSize: 10,
    fontWeight: 'bold',
  },
  redDotLabel: {
    fontSize: 10,
    fontWeight: 'bold',
  },
  sliderLabel: {
    fontSize: 10,
    fontWeight: 'bold',
  },
});

export default pdfDocStyles;
